import { RoutePaths } from '../constants';
import { categories, type Category } from '../data/categories';

/**
 * Находит ID категории по её названию
 * @param name - название категории
 * @returns ID категории или undefined, если категория не найдена
 */
function getCategoryId(name?: string): string | undefined {
    if (!name) {
        return undefined;
    }

    const category = categories.find((cat: Category) => cat.name === name);

    return category?.id;
}

/**
 * Возвращает ссылку на категорию по ее названию
 * @param name - название категории
 * @returns ссылка категории или на главную, если категория не найдена
 */
export function getCatagoryLink(name: string) {
    const id = getCategoryId(name);

    if (!id) {
        return RoutePaths.Main;
    }

    return `${RoutePaths.Category}/${id}`;
}
